export default "__VITE_ASSET__CEEqA7n0__"